export default __webpack_public_path__ + "static/tad_suv_2-389e3903025ad2ae76f36b41f24a5089.jpeg";